import { DateTime } from 'luxon'
import { isValid } from 'date-fns'
import { DatePatternWithTime, LongDatePattern } from '@components/forms/utils/RegexValidation'

export const validateDateFormatWithTime = (value?: string | null): boolean => {
  if (!value) {
    return true
  }

  if (LongDatePattern.test(value)) {
    const date = new Date(value)

    if (isValid(date)) {
      const formatedDate = DateTime.fromJSDate(date).toFormat('dd.MM.yyyy HH:mm')
      return DateTime.fromFormat(formatedDate, 'dd.MM.yyyy HH:mm').isValid
    }

    return false
  }

  if (DatePatternWithTime.test(value)) {
    const dateTime = DateTime.fromFormat(value, 'dd.MM.yyyy HH:mm')
    return dateTime.isValid
  }

  return false
}
